/*
 * File: src/components/OutstandingOrders/OutstandingOrdersHeader.jsx
 * Purpose: Renders the sortable header row for the Outstanding Orders table.
 */

import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

function OutstandingOrdersHeader({ sortBy, sortDir, onSort }) {
  const headers = [
    { key: 'SalesOrderNo', label: 'Sales Order #' },
    { key: 'OrderDate', label: 'Order Date' },
    { key: 'ShipToName', label: 'Ship To Name' },
    { key: 'CustomerPONo', label: 'Customer PO #' },
    { key: 'FormattedOrderType', label: 'Order Type' },
    { key: 'ShipVia', label: 'Ship Via' },
    { key: 'Rep1', label: 'Reps' },
    { key: 'ShippingStatus', label: 'Shipping Status' },
    { key: 'ItemCode', label: 'Item Code' },
    { key: 'Qty', label: 'Quantity' },
    { key: 'PurchaseOrderNo', label: 'Purchase Order #' },
    { key: 'PurchaseOrderDate', label: 'Purchase Order Date' },
  ];

  return (
    <TableHead>
      <TableRow>
        {headers.map((header) => {
          const isSortable = header.sortable !== false;
          const isActive = isSortable && sortBy === header.key;

          return (
            <TableCell key={header.key} data-cy={`header-${header.key}`}>
              {isSortable ? (
                <TableSortLabel
                  active={isActive}
                  direction={isActive ? sortDir : 'asc'}
                  onClick={() => onSort(header.key)}
                >
                  {header.label}
                </TableSortLabel>
              ) : (
                header.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

OutstandingOrdersHeader.propTypes = {
  sortBy: PropTypes.string,
  sortDir: PropTypes.oneOf(['asc', 'desc']),
  onSort: PropTypes.func,
};

OutstandingOrdersHeader.defaultProps = {
  sortBy: 'OrderDate',
  sortDir: 'desc',
  onSort: () => {},
};

export default React.memo(OutstandingOrdersHeader);
